<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/tag.svg" size="2"></app-svg>
  <h1>Edit Tag</h1>
  <form [formGroup]="form" (ngSubmit)="save()">
    <app-input-field [control]="form.controls.name" [noLabel]="true" [big]="true">
      <input type="text" formControlName="name" data-test-id="edit-tag-field" />
    </app-input-field>
    <div class="colors">
      @for (color of colors; track color) {
      <div class="color {{ color }}" [class.active]="color === newColor" (click)="newColor = color"></div>
      }
    </div>
    <button
      appButton
      name="confirm"
      location="edit-tag-dialog"
      data-test-id="edit-tag-confirm"
      color="primary"
      height="4"
      size="3"
      shape="round"
      spacing="full"
    >
      Update
    </button>
  </form>
  <button
    appButton
    name="delete"
    location="edit-tag-dialog"
    color="simple-warn"
    shape="round"
    data-test-id="delete-tag"
    [hasIcon]="true"
    [center]="true"
    class="delete-button"
    (click)="deleteTag()"
  >
    <app-svg src="/assets/icons/trash.svg"></app-svg>
    <span>Delete Tag</span>
  </button>
</div>
